import NoImage from "@assets/images/no-image.svg";

export const getProductFromBoxList = ({ externalId, boxProductList }) =>
  boxProductList.length ? boxProductList.find((item) => +item?.externalId === +externalId) : null;

export const removeProduct = ({ externalId, boxProductList, handleBoxProductList }) => {
  const handleList = boxProductList.filter((value) => {
    return +value.externalId !== +externalId;
  });
  handleBoxProductList([...handleList]);
};

export const handleQuantityOfProductInBox = ({
  externalId,
  newQuantity,
  product,
  boxProductList,
  handleBoxProductList,
  addQuantityFlag = false,
}) => {
  // used addQuantity flag that tells function to add quantity in existing count
  externalId = +externalId;
  const productInBoxList = getProductFromBoxList({ externalId, boxProductList });
  if (productInBoxList) {
    const updatedList = boxProductList.map((item) => {
      if (item.externalId === externalId) {
        return {
          ...item,
          count: addQuantityFlag ? item.count + newQuantity : newQuantity,
        };
      }
      return item;
    });
    handleBoxProductList(updatedList);
  } else {
    handleBoxProductList([
      {
        externalId,
        count: newQuantity || 1,
        ...product,
      },
      ...boxProductList,
    ]);
  }
};

export const getDefaultSelectedProducts = ({ medleySets, medleyItemSetId }) =>
  medleySets
    .find(({ id }) => String(id) === String(medleyItemSetId))
    ?.medleyComponents.map(({ productId, price, quantity }) => ({
      externalId: productId,
      prices: [Number(price)],
      count: quantity,
    })) || [];

export const getProductRelatedData = ({ boxProductList, fetchedProducts }) =>
  boxProductList.map((item) => {
    const selectedProduct = fetchedProducts.find(({ variants }) =>
      variants.some(({ externalId }) => String(externalId) === String(item.externalId)),
    );
    if (!selectedProduct) return item;
    const selectedVariant = selectedProduct.variants.find(
      ({ externalId }) => String(externalId) === String(item.externalId),
    );
    const image =
      selectedVariant?.baseImage ||
      selectedProduct?.baseImage ||
      selectedProduct?.variantImages?.[0] ||
      NoImage;
    const optionValues = selectedVariant?.optionTypes || [];
    return { ...item, image, name: selectedProduct.name, slug: selectedProduct.slug, optionValues };
  });
